import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../stores/actionsList";

class SingleProductVariants extends Component {

    state = {

        save: false,
        collapsOpen: { 0: true },

        info: {
            available: true,
            status: 1
        },

        activeVariants: {},
        variantsPriceDifferences: {},

    }




    plusNum() {


        this.props.actions.addToCart({ data: this.props.info, product: this.state.product, finalPrice: this.state.finalPrice })

    }


    collapsOpen = (index) => {
        let open = this.state.collapsOpen
        open[index] = !open[index]
        this.setState(open)
    }






    checkVariantsPrices = () => {
        if (Array.isArray(this.props?.product?.variants) && this.props.activeVariants) {
            let activeVariants = this.props.activeVariants
            // let variants = this.props?.product?.variants

            if (Array.isArray(this.props?.product?.inventory?.variants)) {
                let final = {}
                let variantInventory = this.props?.product?.inventory?.variants
                let price = this.props?.product?.price?.final
                let variantsCount = this.props?.product?.variants.length


                variantInventory.forEach(element => {

                    if (element?.price?.final != price && element?.price?.final != null) {

                        let shouldBeConsidered = {}
                        let shouldNotBeConsidered = {}


                        for (const [key, value] of Object.entries(element.attributes)) {

                            // console.log(activeVariants)
                            // console.log(key, value, activeVariants[key])
                            if (activeVariants[key] == value) {
                                shouldBeConsidered[key] = { option: value, price: element.price }
                            } else {
                                shouldNotBeConsidered[key] = { option: value, price: element.price }
                            }

                        }

                        if (shouldBeConsidered) {
                            // console.log(shouldBeConsidered)
                            // console.log(element)
                            let keysLength = Object.keys(shouldBeConsidered).length
                            if (keysLength == variantsCount) {
                                final = shouldBeConsidered
                            }

                            if (keysLength == variantsCount - 1) {
                                final = shouldNotBeConsidered
                            }

                        }
                    }

                })

                // console.log(final)
                this.setState({ variantsPriceDifferences: final })

            }
        }
    }

    changeVariant = (variant, option) => {

        let activeVariants = { ...this.props.activeVariants }

        if (variant.name) {
            let name = variant.name.toLowerCase()
            if (!activeVariants[name]) {
                activeVariants[name] = {}
            }
            activeVariants[name] = option

            // console.log(activeVariants)
            this.props.setActiveVariant(activeVariants, () => {
                this.checkVariantsPrices()
            })
        }
    }

    changeAdditional = (additional, option, isSelected) => {

        let activeAdditionals = this.state.activeAdditionals ? { ...this.state.activeAdditionals } : {}


        if (additional.type == 'text') {
            activeAdditionals[additional.title] = { text: { value: option } }
            if (!option || option.trim == '') {
                delete activeAdditionals[additional.title]
            }
            this.setState({ activeAdditionals })
            return
        }



        if (additional.type == 'singleSelect') {
            delete activeAdditionals[additional.title]
        }

        if (!activeAdditionals[additional.title]) {
            activeAdditionals[additional.title] = {}
        }



        if (isSelected) {
            delete activeAdditionals[additional.title][option.label]
        } else {
            activeAdditionals[additional.title][option.label] = { value: true }
        }

        if (Object.keys(activeAdditionals[additional.title]).length == 0) {
            delete activeAdditionals[additional.title]
        }

        this.setState({ activeAdditionals })


    }


    render() {

        return (

            <div className=''>
                {Array.isArray(this.props?.product?.variants) == true && this.props?.product?.variants.map((variant, index) => {
                    return (
                        <div className='mb-3'>
                            <p className='font-size-16 text-bold text-normal mb-2'>{variant?.name}</p>
                            <div className='flexc flex-wrap'>
                                {Array.isArray(variant.options) && variant.options.map((option, index) => {
                                    if (option.trim() != '') {
                                        let isSelectedVariant = false
                                        let name = variant.name ? variant.name.toLowerCase() : null

                                        if (name && this.props.activeVariants && this.props.activeVariants[name]) {
                                            if (this.props.activeVariants[name] == option) {
                                                isSelectedVariant = true
                                            }
                                        }

                                        return (
                                            <div className=' mrd-2 mb-1'>
                                                <button className=' br-4   flexc ' onClick={() => this.changeVariant(variant, option)} style={{ border: isSelectedVariant ? '0px solid transparent' : '1px solid #aaa' }}>
                                                    <div className='br-4 px-3 py-1 flexc' style={{ padding: '0px', border: isSelectedVariant ? '2px solid #007aff' : '1px solid transparent', }}>

                                                        <p className='text-small text-semibold'>{option}</p>

                                                        {(this.state.variantsPriceDifferences[name] && this.state.variantsPriceDifferences[name].option == option) && (
                                                            <p className='text-small mld-2 text-semibold' style={{ color: '#000' }}>${this.state.variantsPriceDifferences[name]?.price?.final}</p>
                                                        )
                                                        }
                                                    </div>
                                                </button>
                                            </div>
                                        )
                                    }
                                })}
                            </div>
                        </div>
                    )
                })}

            </div >

        )
    }
}

export default SingleProductVariants
